import { nodeTypeOptions } from '@app/ccf/options/node-options';
import { SuppliersProximityEnum, TypeOfSuppliersEnum } from '@shared/api/types';
import { SelectOption } from '@shared/components/form/select-form-field';

export const supplyOriginSitesOptions: SelectOption[] = nodeTypeOptions.filter(
  (option) =>
    option.value !== 'consumer_home' &&
    option.value !== 'restaurant' &&
    option.value !== 'central_kitchen' &&
    option.value !== 'retail_store' &&
    option.value !== 'transport_hub'
);

export const supplyInterchangeSiteOptions = [
  {
    label: 'Depot',
    value: 'depot',
  },
  {
    label: 'Port',
    value: 'port',
  },
];

export const supplyDestinationSiteOptions = [
  ...nodeTypeOptions.filter(
    (option) =>
      option.value !== 'consumer_home' &&
      option.value !== 'restaurant' &&
      option.value !== 'central_kitchen' &&
      option.value !== 'retail_store' &&
      option.value !== 'national_distribution_centre' &&
      option.value !== 'regional_distribution_centre'
  ),
];

export const typeOfSuppliersOptions: SelectOption[] = [
  {
    label: 'Farm / producer',
    value: TypeOfSuppliersEnum['farm_producer'],
  },
  {
    label: 'Manufacturer',
    value: TypeOfSuppliersEnum['manufacturer'],
  },
  {
    label: 'Wholesaler',
    value: TypeOfSuppliersEnum['wholesaler'],
  },
  {
    label: 'International supplier',
    value: TypeOfSuppliersEnum['international_supplier'],
  },
];

export const supplierProximityOptions: SelectOption[] = [
  {
    label: 'Local - e.g within same city',
    value: SuppliersProximityEnum['local'],
  },
  {
    label: 'Regional - e.g within same county',
    value: SuppliersProximityEnum['regional'],
  },
  {
    label: 'National',
    value: SuppliersProximityEnum['national'],
  },
];
